module.exports = __webpack_public_path__ + "img/api-hub.24c484c5.svg";